import React, { Component } from "react";
import { withListSensors } from "../../../shared/containers/containerListSensors";
import { withDevices } from "../../../shared/containers/containerDevices";
import { states } from "../../../reducers/queriesStates";
import { withCurrentDevices } from "../../../shared/containers/containerCurrentDevice";

import styles from "./cmsConnectorSensorTools.module.scss";
import CmsConnectorSensorCreateForm from "./CmsConnectorSensorCreateForm";
import CmsConnectedSensorsList from "./CmsConnectedSensorsList";
import DataAnalyse from "./DataAnalyse/DataAnalyse";

class CmsConnectorSensorTools extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { dataStateProtocolMarkers, onGetProtocolMarkers } = this.props;

    if (dataStateProtocolMarkers === states.NOT_REQUESTED) {
      onGetProtocolMarkers();
    }
  }

  setTabIndex(tabIndex) {
    this.setState({ tabIndex });
  }

  getTabs() {
    const { tabIndex } = this.state;
    const titles = ["Привилегии роли пользователя", "Пользовательские Привилегии вне роли", "Области владения"];

    return titles.map((item, index) => {
      return (
        <div key={index} className={tabIndex === index ? styles.cmsTabActive : styles.cmsTab} onClick={this.setTabIndex.bind(this, index)}>
          {item}
        </div>
      );
    });
  }

  getTabView() {
    const { tabIndex } = this.state;

    switch (tabIndex) {
      default:
        return null;
    }
  }

  render() {
    const { protocolMarkers } = this.props;

    if (protocolMarkers === null) {
      return null;
    }

    return (
      <div className={styles.cmsConnectorSensorContainer}>
        <DataAnalyse />

        <div style={{ backgroundColor: "#dddddd15", padding: "10px"}}>
          <CmsConnectorSensorCreateForm />
          <CmsConnectedSensorsList />
        </div>
      </div>
    );
  }
}

export default withCurrentDevices(withDevices(withListSensors(CmsConnectorSensorTools)));
